import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const RichTextEditor = ({ value, onChange, placeholder, className }) => {
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          {
            // First group: brights picked to stay readable on the slate popup
            // background (#546675→#647889); rest: the original set.
            color: [
              '#ffffff',
              '#fff3ec', // semi-white
              '#f1b71b', // gold-300
              '#ffd45f', // bright gold
              '#fb923c', // bright orange
              '#e91e63', // pink (red-crashed)
              '#b49ef1', // lilac
              '#38bdf8', // sky blue
              '#4ade80', // bright green
              '#000000',
              '#3169d9',
              'rgb(192, 93, 30)',
              '#10b981',
              '#eab308',
              '#6b7280',
              '#fbbf24',
            ],
          },
        ],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image'],
        [{ align: [] }],
        ['clean'],
      ],
    }),
    []
  );

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'color',
    'list',
    'bullet',
    'link',
    'image',
    'align',
  ];

  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      modules={modules}
      formats={formats}
      placeholder={placeholder || 'Enter announcement content...'}
      className={className}
    />
  );
};

export default RichTextEditor;
